import * as angular from "angular";
import { NotificationService } from "../services/notification.service";
import { ToastUtils } from "../helper/toast.helper";
import { HouseOccupantDataProvider } from "./house-occupant.dp";
import { HouseDataProvider } from "./house.dp";

export class NotificationDataProvider {
    private $q: any;
    private readonly $timeout: any;
    private readonly service: NotificationService;
    private readonly toast: ToastUtils;
    private houseOccupantDataProvider: HouseOccupantDataProvider;
    private houseDataProvider: HouseDataProvider;

    public notifications: any[] | null = null;
    public uid: string | number | undefined;
    public unseen: number = 0;
    public unseenIssues: number = 0;
    public readonly personalNotificationTypes = [
        "QUERY_ASSIGNMENT",
        "QUERY_EMAIL",
        "RAW_EMAIL",
        "DUPLICATE",
    ];

    constructor(
        $q: any,
        NotificationService: NotificationService,
        HouseOccupantDataProvider: HouseOccupantDataProvider,
        HouseDataProvider: HouseDataProvider,
        $timeout: any,
        ToastUtils: ToastUtils
    ) {
        this.$q = $q;
        this.service = NotificationService;
        this.$timeout = $timeout;
        this.toast = ToastUtils;
        this.houseOccupantDataProvider = HouseOccupantDataProvider;
        this.houseDataProvider = HouseDataProvider;
    }

    setUID(setUID: number | string): void {
        this.uid = setUID;
    }

    getNotificationCount(): Promise<number> {
        const deferred = this.$q.defer();

        this.service.count().then(
            (response: object) => {
                const json = response["data"];
                this.unseen = parseInt(json.data);
                deferred.resolve(this.unseen);
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getUnseenIssuesCount(): Promise<number> {
        const deferred = this.$q.defer();
        this.service.countIssues().then(
            (response: object) => {
                const json = response["data"];
                this.unseenIssues = parseInt(json.data);
                deferred.resolve(this.unseenIssues);
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    getNotifications(): Promise<Array<any>> {
        const deferred = this.$q.defer();
        let offset = {};
        if (this.notifications === null) {
            this.notifications = [];
        } else if (this.notifications.length > 0) {
            //no scrolling behaviour anymore
            return this.$q.resolve(this.notifications);
            // offset = {offset:this.notifications[this.notifications.length-1].notificationid}
        }

        this.service.all(offset).then(
            (response: object) => {
                const json = response["data"];
                for (let i = 0; i < json.data.length; i++) {
                    this.notifications.push(json.data[i]);
                }
                this.unseen = parseInt(json.unseen);
                deferred.resolve(json.data);
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    setAllSeen(): void {
        this.unseen = 0;
        angular.forEach(this.notifications, (notification: any) => {
            notification.notificationseen = 1;
        });

        this.service.setAllSeen({});
    }

    setIssuesSeen(): void {
        this.unseenIssues = 0;
        this.service.setIssuesSeen({});
    }

    notificationWithID(notificationid: number): object | null {
        for (let i = 0; i < this.notifications.length; i++) {
            if (this.notifications[i].notificationid == notificationid) {
                return this.notifications[i];
            }
        }
        return null;
    }

    replaceNotification(notification: any): void {
        this.$timeout(() => {
            let existingNotification = this.notificationWithID(
                notification.notificationid
            );

            if (existingNotification) {
                angular.extend(existingNotification, notification);
            } else {
                this.notifications.unshift(notification);
                this.unseen += 1;
            }
        });
    }

    processSocketUpdate(): void {
        this.getNotificationCount();
        this.getUnseenIssuesCount();
    }

    processSocketCreate(socketData: any): void {
        if (
            this.personalNotificationTypes.indexOf(
                socketData.notificationtype
            ) == -1 ||
            socketData.uid == this.uid
        ) {
            if (
                socketData.notificationtype == "BULK_DELETE" ||
                socketData.notificationtype == "BULK_EDIT"
            ) {
                this.houseOccupantDataProvider.getAll(0, false);
                this.houseDataProvider.getAll(0, false);
            }
            let toastMessage = socketData.notificationmessage
                ? socketData.notificationheading +
                  " - " +
                  socketData.notificationmessage
                : socketData.notificationheading;
            if (this.notifications) {
                this.$timeout(() => {
                    this.notifications.unshift(socketData);
                    this.unseen += 1;
                });
                this.toast.success(toastMessage, 6000);
            } else {
                this.unseen += 1;
                this.toast.success(toastMessage, 6000);
            }
        }

        if (socketData.notificationtype === "QUERY_ASSIGNMENT") {
            this.getUnseenIssuesCount();
        }
    }
}
angular
    .module("vcDataProvider")
    .service("NotificationDataProvider", NotificationDataProvider);
